"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("../datapoints");
var owa_mail_list_actions_1 = require("owa-mail-list-actions");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var getSelectedTableView_1 = require("owa-mail-list-store/lib/utils/getSelectedTableView");
var owa_mail_table_loading_actions_1 = require("owa-mail-table-loading-actions");
var undoActions = require("owa-mail-undo");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Selects a filter on a current selected table view
 * @param viewFilter viewFilter to select
 * @param actionSource source of this action
 */
exports.default = legacy_1.action('selectFilter', datapoints_1.default.selectFilter)(function selectFilter(viewFilter, actionSource) {
    var selectedTableView = getSelectedTableView_1.default();
    if (viewFilter == 'UserCategory') {
        throw new Error('ViewFilter should not be user category when select filter is called');
    }
    var tableQuery = owa_mail_list_actions_1.createMailFolderTableQuery(selectedTableView.tableQuery.folderId, selectedTableView.tableQuery.listViewType, owa_mail_list_store_1.getFocusedFilterForTable(selectedTableView), viewFilter, null /* categoryName */, // Cateogries and view filters ['All', 'Unread', 'To Me', 'Flagged'] cannot exist together as when a category folder is selected. The view filter needs to be set to UserCategory
    owa_mail_list_store_1.getSortByForTable(selectedTableView) // Retain the sort column when selecting filter
    );
    undoActions.clearLastUndoableAction();
    return owa_mail_table_loading_actions_1.loadTableViewFromTableQuery(tableQuery, null /* startLoadTableViewDatapoint */, actionSource);
});
//# sourceMappingURL=selectFilter.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-filter-actions/lib/actions/selectFilter.js
// module id = 2078
// module chunks = 46 105